export default __webpack_public_path__ + "static/media/dateline.38307c57.png";